/*
 * Copyright (c) 2024. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from "react";
import clsx from "clsx";
import FooterLogo from "pages/Front/Booking/BookingFooter/FooterLogo";
import FooterSidebarLeft from "pages/Front/Booking/BookingFooter/FooterSidebarLeft";
import FooterSidebarCenter from "pages/Front/Booking/BookingFooter/FooterSidebarCenter";
import {useTranslation} from "react-i18next";
import FooterSidebarRight from "pages/Front/Booking/BookingFooter/FooterSidebarRight";
import FacebookFIcon from "components/Icons/FontAwesome/FacebookFIcon";
import InstagramIcon from "components/Icons/FontAwesome/InstagramIcon";
import TikTokIcon from "components/Icons/FontAwesome/TikTokIcon";
import YoutubeIcon from "components/Icons/FontAwesome/YoutubeIcon";
import LinkedInInIcon from "components/Icons/FontAwesome/LinkedInInIcon";
import FeatherIcon from "components/FeatherIcon";

interface BookingFooterNewProps {
    className?: string;
    isFullWidth?: boolean;
}

const BookingFooterNew = (props: BookingFooterNewProps) => {
    const {t} = useTranslation();

    return (
        // <div className={clsx("BookingFooterNew bg-black text-white inset-x-0 text-sm duration-0 lg:text-base py-6 px-4", props.isFullWidth ? "" : "xl:px-0", props.className)}>
        <div
            className={clsx(
                "BookingFooterNew relative text-white pb-8 z-10 px-[16px] mt-32 2xl:mt-48 pt-12 md:px-0 2xl:pt-24 md:pb-12 bg-black flex flex-col",
                props.className
            )}
        >
            <div className={"absolute inset-x-0 " + "pt-8 2xl:pt-24 " + "-top-8 2xl:-top-24 " + "h-16 md:h-24" + "w-full overflow-hidden "}>
                <div className={"relative w-full " + "-translate-y-8 2xl:-translate-y-24"}>
                    <img src={"/img/background/bg-footer-black.svg"} className={"w-full  h-full object-cover object-top"} />
                </div>
            </div>
            <FooterLogo />

            {/*Booking max-w-full xl:max-w-7xl w-full items-center m-auto flex flex-col grow pt-6 pb-6 px-4 xl:px-0*/}

            {/*<div className={clsx("max-w-full w-full h-full flex flex-col items-center justify-center m-auto", props.isFullWidth ? "" : "xl:max-w-7xl")}>*/}
            {/*<div className={clsx("max-w-full w-full h-full flex flex-col items-center justify-center m-auto")}>*/}
            {/*<div className={clsx("max-w-[1200px] container mx-auto flex flex-col gap-y-8 z-10")}>*/}
            <div className={clsx("max-w-full xl:max-w-7xl w-full m-auto px-4 xl:px-0 flex flex-col gap-y-8 z-10")}>
                <div className={"flex flex-col md:flex-row w-full justify-between gap-x-8 gap-y-6 md:gap-y-8 md:pb-4 text-base md:text-[20px] font-medium"}>
                    <FooterSidebarLeft />
                    <FooterSidebarCenter />
                    <FooterSidebarRight />
                </div>

                <div className={"text-center border-t border-[#c0bcbc] pt-8 md:pt-12"}>
                    <div className={"w-full flex flex-col md:flex-row gap-y-5 gap-x-6 md:gap-x-8 lg:gap-x-8 justify-start text-center lg:text-left"}>
                        <h2 className={"font-zuume font-bold text-[32ppx] md:text-[48px] shrink-0 leading-none"}>{t("Follow us")}:</h2>
                        <div className={"w-full flex flex-row flex-wrap items-center gap-x-4 md:gap-x-6 lg:gap-x-12 justify-center md:justify-start"}>
                            <a className={"group"} href={"https://www.facebook.com/people/ArboPark/61556596647925/"} rel="noreferrer" target={"_blank"}>
                                <FacebookFIcon className={"size-7 flex-none text-white group-hover:!text-[#1877f2]"} />
                            </a>
                            <a className={"group"} href={"https://www.instagram.com/arbopark.ch/"} rel="noreferrer" target={"_blank"}>
                                <InstagramIcon className={"size-7 flex-none text-white group-hover:text-[#c32aa3]"} />
                            </a>
                            <a className={"group"} href={"https://www.tiktok.com/@arbopark.ch"} rel="noreferrer" target={"_blank"}>
                                <TikTokIcon className={"size-7 flex-none text-white group-hover:text-[#69c9d0]"} />
                            </a>
                            <a className={"group"} href={"https://www.youtube.com/@arboparkch"} rel="noreferrer" target={"_blank"}>
                                <YoutubeIcon className={"size-7 flex-none text-white group-hover:text-[#ff0000]"} />
                            </a>
                            <a className={"group"} href={"https://www.linkedin.com/company/arbopark/"} rel="noreferrer" target={"_blank"}>
                                <LinkedInInIcon className={"size-7 flex-none text-white group-hover:text-[#0a66c2]"} />
                            </a>
                        </div>
                        <a className="newsletter" href="https://www.arbopark.ch/newsletter/">
                            <div className="font-bold text-base md:text-[20px] inline-flex items-center text-center w-auto gap-2 transform-gpu duration-150 transition-all cursor-pointer no-underline text-black hover:text-black rounded-xl px-5 py-2.5 bg-gradient-arboYellowOrange hover:brightness-90">
                                <span>Newsletter</span>
                                <FeatherIcon name={"arrow-right"} className={"size-6 flex-none"} strokeWidth={3} />
                            </div>
                        </a>
                    </div>
                </div>

                {/*<div className={"grid grid-cols-12 gap-x-4 gap-y-8 lg:gap-y-0 leading-4 w-full"}>*/}
                {/*    <div className={"col-span-12 sm:col-span-6 lg:col-span-3 flex flex-col"}>*/}
                {/*        <h2 className={"font-bold mb-4 text-xl text-center sm:text-left"}>*/}
                {/*            {t("Address")} / {t("Contact")}*/}
                {/*        </h2>*/}
                {/*        <div className={"flex flex-col gap-y-1.5 mb-6 text-center sm:text-left"}>*/}
                {/*            <span className={"font-semibold"}>{hall.name}</span>*/}
                {/*            <span>Textilstrasse 7</span>*/}
                {/*            <span>9320 Arbon</span>*/}
                {/*            <span>{t("Switzerland")}</span>*/}
                {/*        </div>*/}
                {/*        <div className={"flex flex-col gap-y-1.5 mb-6"}>*/}
                {/*            <span className={"inline-flex items-center justify-center sm:justify-start"}>*/}
                {/*                <MapIcon className={"w-3 h-3 mr-1 lg:mr-2"} />*/}
                {/*                <a className={"hover:text-arbo-orange"} href={"https://maps.app.goo.gl/YNYb3iz9BxUB7mS36"} rel={"noreferrer"} target={"_blank"}>*/}
                {/*                    {t("Open in Google Maps")}*/}
                {/*                </a>*/}
                {/*            </span>*/}
                {/*        </div>*/}
                {/*        <div className={"flex flex-col gap-y-1.5"}>*/}
                {/*            <span className={"inline-flex items-center justify-center sm:justify-start"}>*/}
                {/*                <PhoneIcon className={"w-3 h-3 mr-1 lg:mr-2"} />*/}
                {/*                <a className={"hover:text-arbo-orange"} href={`tel:${hall.contact}`}>*/}
                {/*                    {hall.contact}*/}
                {/*                </a>*/}
                {/*            </span>*/}
                {/*            <span className={"inline-flex items-center justify-center sm:justify-start"}>*/}
                {/*                <AtSymbolIcon className={"w-3 h-3 mr-1 lg:mr-2"} />*/}
                {/*                <a className={"hover:text-arbo-orange"} href={`mailto:${hall.email}`}>*/}
                {/*                    {hall.email}*/}
                {/*                </a>*/}
                {/*            </span>*/}
                {/*        </div>*/}
                {/*    </div>*/}

                {/*    <div className={"col-span-12 sm:col-span-6 lg:col-span-3 flex flex-col"}>*/}
                {/*        <h2 className={"font-bold mb-4 text-xl text-center sm:text-left"}>{t("Opening hours")}</h2>*/}
                {/*        <table className={"w-full max-w-xs mx-auto sm:mx-0"}>*/}
                {/*            <tbody>*/}
                {/*                {openingHours &&*/}
                {/*                    Object.entries(openingHours).map(([key, hours]) => {*/}
                {/*                        const days = hours.map(hour => t(getDayName(hour.day))).join(", ");*/}
                {/*                        const [openingHoursFrom, openingHoursTo] = key.split("-");*/}
                {/*                        const hoursText =*/}
                {/*                            openingHoursFrom === "0" && openingHoursTo === "0"*/}
                {/*                                ? t("Closed")*/}
                {/*                                : openingHoursFrom + ":00 " + t("h") + " - " + openingHoursTo + ":00 " + t("h");*/}

                {/*                        return (*/}
                {/*                            <tr key={key} className={"lg:flex lg:flex-col lg:mb-1 lg:last-of-type:mb-0"}>*/}
                {/*                                <td className="pr-1.5 pb-1.5 font-semibold">{days}</td>*/}
                {/*                                <td className="pr-1.5 pb-1.5">{hoursText}</td>*/}
                {/*                            </tr>*/}
                {/*                        );*/}
                {/*                    })}*/}
                {/*            </tbody>*/}
                {/*        </table>*/}
                {/*    </div>*/}

                {/*    <div className={"col-span-12 sm:col-span-6 lg:col-span-3 flex flex-col"}>*/}
                {/*        <h2 className={"font-bold mb-4 text-xl text-center sm:text-left"}>{t("Follow us")}</h2>*/}
                {/*        <div className={"inline-flex items-center gap-x-3 justify-center sm:justify-start"}>*/}
                {/*            <a className={"group"} href={"https://www.facebook.com/people/ArboPark/61556596647925/"} rel="noreferrer" target={"_blank"}>*/}
                {/*                <FacebookFIcon className={"w-5 h-5 flex-none text-white group-hover:!text-arbo-orange"} />*/}
                {/*            </a>*/}
                {/*            <a className={"group"} href={"https://www.instagram.com/arbopark.ch/"} rel="noreferrer" target={"_blank"}>*/}
                {/*                <InstagramIcon className={"w-6 h-6 flex-none text-white group-hover:text-arbo-orange"} />*/}
                {/*            </a>*/}
                {/*            <a className={"group"} href={"https://www.tiktok.com/@arbopark.ch"} rel="noreferrer" target={"_blank"}>*/}
                {/*                <TikTokIcon className={"w-5 h-5 flex-none text-white group-hover:text-arbo-orange"} />*/}
                {/*            </a>*/}
                {/*            <a className={"group"} href={"https://www.youtube.com/@arboparkch"} rel="noreferrer" target={"_blank"}>*/}
                {/*                <YoutubeIcon className={"w-6 h-6 flex-none text-white group-hover:text-arbo-orange"} />*/}
                {/*            </a>*/}
                {/*            <a className={"group"} href={"https://www.linkedin.com/company/arbopark/"} rel="noreferrer" target={"_blank"}>*/}
                {/*                <LinkedInInIcon className={"w-6 h-6 flex-none text-white group-hover:text-arbo-orange"} />*/}
                {/*            </a>*/}
                {/*        </div>*/}
                {/*    </div>*/}

                {/*    <div className={"col-span-12 sm:col-span-6 lg:col-span-3 flex flex-col"}>*/}
                {/*        <h2 className={"font-bold mb-4 text-xl text-center sm:text-left"}>{t("Information")}</h2>*/}
                {/*        <div className={"flex flex-col gap-y-1.5"}>*/}
                {/*            <span className={"inline-flex items-center justify-center sm:justify-start"}>*/}
                {/*                <LinkIcon className={"w-3 h-3 mr-1 lg:mr-2"} />*/}
                {/*                <a className={"hover:text-arbo-orange"} href={LinkTo.terms()}>*/}
                {/*                    {t("Terms and conditions")}*/}
                {/*                </a>*/}
                {/*            </span>*/}
                {/*            <span className={"inline-flex items-center justify-center sm:justify-start"}>*/}
                {/*                <LinkIcon className={"w-3 h-3 mr-1 lg:mr-2"} />*/}
                {/*                <a className={"hover:text-arbo-orange"} href={LinkTo.impressum()}>*/}
                {/*                    {t("Impressum")}*/}
                {/*                </a>*/}
                {/*            </span>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}
            </div>
        </div>
    );
};

export default BookingFooterNew;
